import { Card } from "@/components/ui/card";

const TONES = {
  blue: "bg-blue-50 text-blue-600",
  green: "bg-emerald-50 text-emerald-600",
  amber: "bg-amber-50 text-amber-600",
  red: "bg-rose-50 text-rose-600",
};

// Kartu statistik Master (gaya sama dengan StatCard di Beranda area)
export default function MasterStatCard({ icon: Icon, label, value, sub, tone = "blue", testid }) {
  return (
    <Card data-testid={testid} className="p-5 border-slate-200 shadow-none rounded-lg">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-500 truncate">{label}</p>
          <p className="text-3xl font-black tracking-tight text-slate-900 mt-1.5 tabular-nums">{value}</p>
          {sub && <p className="text-xs text-slate-500 mt-1 truncate">{sub}</p>}
        </div>
        <div className={`h-10 w-10 shrink-0 rounded-lg flex items-center justify-center ${TONES[tone]}`}><Icon className="h-5 w-5" /></div>
      </div>
    </Card>
  );
}
